// Class-variable transform gate for the main compiler entry pipeline.
// Example: vendor-fast mode skips selector rewrites even when variables exist.

// Check whether the class-variable transform stage is required.
export function shouldApplyClassVariableTransform(
  mode: 'full' | 'vendor-fast',
  classVariables: Record<string, string>,
  objectVariables: Record<string, Record<string, string>>,
  arrayVariables: Record<string, string[]>,
): boolean {
  // Check whether vendor-fast mode should skip selector transforms.
  if (mode === 'vendor-fast') {
    // Return false in vendor-fast mode by design.
    return false
  } else if (hasAnyKey(classVariables)) {
    // Return true when class variables are defined.
    return true
  } else if (hasAnyKey(objectVariables)) {
    // Return true when object variables are defined.
    return true
  } else if (hasAnyKey(arrayVariables)) {
    // Return true when array variables are defined.
    return true
  } else {
    // Return false when no Lenty variable registries exist.
    return false
  }
}

// Check whether the current object contains at least one own key.
function hasAnyKey(obj: Record<string, unknown>): boolean {
  // Start one fast non-empty object scan without allocating a keys array.
  for (const _ in obj) {
    // Return true when the first key is found.
    return true
  }
  // Return false when the object has no keys.
  return false
}
